webpackJsonp([89328772472945],{

/***/ 832:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"problem","www_url":"http://i-love-u.ch","thema":"sport","issue_month":"April","issue_year":2006,"issue_date":200604,"artist":"ruth","location":"Switzerland","email":"ruth@i-love-u.ch","id":"contribution_188","media_type":"still_image","position_in_section":2,"media_uri":"media/2006/April/still_image/problem02.jpg","media_th_uri":"media/2006/April/still_image/tn_problem02.jpg","still_image_count":4,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_188"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200604-still-image-2-11637b1a1721c0258f84.js